import { Box } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import LeftPanel from './LeftPanel';
import RightPanel from './RightPanel';

import * as styles from './DonationFormBuilder.css';

function Content(): JSX.Element {
  return (
    <Box className={styles.root}>
      <LeftPanel />
      <RightPanel />
    </Box>
  );
}

export default observer(Content);
